<template>
  <main>
    <div class="py-4 pt-5 container-fluid">
      <GridRow>
        <GridCol :size="12">
          <MetaSection>
            <div class="text-right">
              <argon-button :to="{ name: 'Target Konsolidasi' }" isRouteLink outline><font-awesome-icon
                  icon="fa-solid fa-chevron-left" /> Kembali</argon-button>
            </div>
          </MetaSection>
        </GridCol>
        <GridCol :size="12">
          <form action="" @submit.prevent="submit()">
            <cards footerstyle="background-color: #ebeffb;" :useFooter="true">
              <template v-slot:footer>
                <div class="text-right">
                  <div class="d-flex flex-row-reverse gap-2">
                    <ArgonButton type="submit">Simpan</ArgonButton>
                    <ArgonButton :to="{ name: 'Target Konsolidasi' }" isRouteLink outline>Batalkan</ArgonButton>
                  </div>
                </div>
              </template>
              <FieldsetComponent title="Informasi Umum"
                description="Pastikan diisi sesuai dengan data yang Anda buat">
                <div class="flex flex-col gap-5">
                  <!-- <form-group label="Nama Penilaian Kerja" idinput="name"
                    invalidmsg="Wajib di isi dan harus di awali dengan alphanumeric">
                    <InputForm type="text" name="name" idinput="name"
                      placeholder="Silakan tulis nama penilaian kinerja disini..." v-model="data.nama_penilaian_kinerja"
                      :isinvalid="!validateInput('name', data.nama_penilaian_kinerja)" required />
                  </form-group> -->

                  <form-group label="Periode Penilaian" idinput="periode_id">
                    <select-form name="periode_id" idinput="periode_id" v-model="data.periode_id" placeholder="Pilih Periode" required :options="list_periode.map((item) => {
                      return {
                        value: item.id,
                        text: item.name,
                      };
                    })" />
                  </form-group>

                  <!-- <form-group label="Cabang Induk">
                    <select-form  placeholder="Silakan pilih cabang induk" required :options="[
                      {
                        value: 'Silakan pilih cabang induk',
                        text: 'Silakan pilih cabang induk',
                      },
                    ]" />
                  </form-group> -->

                  <form-group label="Cabang Induk" idinput="cabang_id">
                    <select-form name="cabang_id" idinput="cabang_id" v-model="data.cabang_id" placeholder="Pilih Cabang" required :options="unitkerja.map((item) => {
                      return {
                        value: item.id,
                        text: item.name,
                      };
                    })" />
                  </form-group>

                  <!-- <form-group label="Jabatan" idinput="jabatan_id">
                    <select-form name="jabatan_id" idinput="jabatan_id" v-model="data.jabatan_id" :disabled="!(this.data.unit_kerja_id != undefined && this.data.unit_kerja_id != '' && this.data.unit_kerja_id != null)" :options="jabatan.map((item) => {
                      return {
                        value: item.id,
                        text: item.name,
                      };
                    })" />
                  </form-group> -->

                  <form-group label="Status">
                    <div class="d-flex flex-row gap-4 align-items-center">
                      <input style="width: 2rem;height: 2rem;" type="radio" value="active" v-model="data.status"
                        name="status" id="status_0" autocomplete="off" required>
                      <label class="m-0" :for="'status_0'">Aktif</label>

                      <input style="width: 2rem;height: 2rem;" type="radio" value="inactive" v-model="data.status"
                        name="status" id="status_1" autocomplete="off" required>
                      <label class="m-0" :for="'status_1'">Non Aktif</label>
                    </div>
                  </form-group>
                </div>
              </FieldsetComponent>

              <FieldsetComponent title="Aspek Target Konsolidasi"
                description="Pastikan target sesuai dengan data">
                <form @submit.prevent v-if="list_aspek_selected.length === 0">
                  <FormGroup label="Tambah Target Konsolidasi">
                    <!-- <button type="submit" class="btn mb-0 btn-outline btn-md null null">Tambah</button> -->
                    <argon-button type="button" outline databstoggle="modal" databstarget="#addAspekModal" @click="resetModalAddAspek()">Tambah Aspek</argon-button>
                  </FormGroup>
                </form>

                <template v-else>
                  <hr>

                  <FormGroup
                    label="Daftar Target Konsolidasi"
                  >
                    <div class="border rounded-3 p-3 mb-4" v-for="item,index in list_aspek_selected" :key="item">
                      <div class="d-flex flex-row gap-2 justify-content-between">
                        <!-- <h6>{{ item?.title || '-' }}{{ item?.jabatan ? ' - '+ item?.jabatan : '' }}</h6> -->
                        <h6>{{ item?.title || '-' }}</h6>
                        <ThreeDotsMenu>
                          <button type="button" @click="editAspek(index, item)" class="text-secondary font-weight-bold text-xs btn btn-link" data-bs-toggle="modal" data-bs-target="#editAspekModal">Ubah</button>
                          <button type="button" @click="deleteAspekSelected(index)" class="text-secondary font-weight-bold text-xs btn btn-link">Hapus</button>
                        </ThreeDotsMenu>
                      </div>

                      <div class="table-responsive" style="text-align: left;">
                          <table class="table">
                            <thead>
                              <tr>
                                <th>Aspek</th>
                                <th width="100">Satuan</th>
                                <th width="100">Target</th>
                                <!-- <th></th> -->
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item_sub, index_sub ) in item?.child" :key=" index_sub">
                                <td>{{ item_sub?.title || '-' }}</td>
                                <!-- <td class="text-capitalize">{{ getSatuan(item_sub?.satuan) || '-' }}</td> -->
                                <td>{{ item_sub?.satuan || '-' }}</td>
                                <td>
                                  <span v-if="item_sub?.satuan?.toLowerCase() === 'rupiah'">
                                    {{
                                      new Intl.NumberFormat('id-ID', {
                                        style: 'currency',
                                        currency: 'IDR',
                                        minimumFractionDigits: 0,
                                      }).format(item_sub?.target || '0')
                                    }}
                                  </span>
                                  <span v-else>
                                    {{
                                      new Intl.NumberFormat('id-ID', {
                                        minimumFractionDigits: 0,
                                      }).format(item_sub?.target || '0')
                                    }} 
                                    <span class="text-capitalize">{{ (item_sub?.satuan?.toLowerCase() === 'persen' ? '%' : item_sub?.satuan) || '-' }}</span>
                                  </span>
                                </td>
                                <!-- <td>
                                  <ThreeDotsMenu>
                                      <button type="button" @click.prevent
                                        class="text-secondary font-weight-bold text-xs btn btn-link" role="link"
                                        data-toggle="tooltip" data-original-title="Delete">Hapus</button>
                                    </ThreeDotsMenu>
                                </td> -->
                              </tr>
                            </tbody>
                          </table>
                      </div>
                    </div>

                    <argon-button type="button" outline databstoggle="modal" databstarget="#addAspekModal" @click="resetModalAddAspek()">Tambah Aspek</argon-button>
                  </FormGroup>
                </template>

              </FieldsetComponent>
            </cards>
          </form>
        </GridCol>
      </GridRow>
    </div>

    <!-- modal add aspek -->
    <div class="modal fade" id="addAspekModal" tabindex="-1" aria-labelledby="addAspekModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <!-- <form @submit.prevent=" saveModal() "> -->
          <form @submit.prevent="">
            <div class="modal-header">
              <h5 class="modal-title" id="addAspekModalLabel">Target Konsolidasi</h5>
              <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
              <span class="p-1 cursor-pointer" data-bs-dismiss="modal" aria-label="Close">
                <font-awesome-icon icon="fa-solid fa-times" />
              </span>
            </div>
            <div class="modal-body">
              <div class="d-flex flex-column">
                <form-group label="Kategori KPI" class="w-100 mb-0">
                  <!-- <ArgonInput
                    placeholder="Silahkan cari pegawai atau nip disni..."
                    icon="fas fa-search"
                    iconDir="right"
                    v-model="keyword"
                  /> -->

                  <div class="form-group">
                    <div class="input-group">
                      <template v-if="!search_aspek_selected">
                        <span class="input-group-text">
                          <i class="fa fa-search" aria-hidden="true"></i>
                        </span>
                        <input type="text" class="form-control" placeholder="Cari kategori KPI.." v-model="keyword_search_aspek" @keyup="searchKeywordAspek()">
                      </template>

                      <template v-else>
                        <!-- <div class="form-control">{{ search_aspek_selected?.title || '' }} - {{ search_aspek_selected?.jabatan || '' }}</div> -->
                        <div class="form-control">{{ search_aspek_selected?.title || '' }}</div>
                        <span class="input-group-text cursor-pointer" @click="removeSearchAspek()">
                          <i class="fa fa-times-circle" aria-hidden="true"></i>
                        </span>
                      </template>
                    </div>
                  </div>
                </form-group>

                <div
                  v-if="keyword_search_aspek.length > 0 && !search_aspek_selected"
                  class="table-responsive border rounded-3 px-2 pt-2"
                  style="text-align: left;"
                >
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Aspek</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="list_search_aspek?.length === 0">
                        <td class="text-center">Data tidak ditemukan</td>
                      </tr>

                      <tr v-for="(item, index) in  list_search_aspek " :key=" index " class="cursor-pointer" @click="chooseSearchAspek(item)">
                        <!-- <td>{{ item?.title || '-' }} - {{ item?.jabatan || '' }}</td> -->
                        <td>{{ item?.title || '-' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>


                <template v-if="search_aspek_selected && Object.keys(search_aspek_selected).length > 0">
                  <hr>

                  <FieldsetComponent
                    :title="search_aspek_selected?.title || '-'"
                    isFieldsetRow
                  >
                    <div class="box-aspek-main">
                      <div class="box-aspek-penilaian" v-for="( item, index ) in search_aspek_selected?.child" :key=" index " :gap="-1">
                        <div class="box-aspek-penilaian__value">
                          <FormGroup label="Aspek Penilaian" idinput="titleaspek">
                            <!-- <input type="text" class="form-control" value="Penambahan Kas Cabang" readonly> -->
                            <div class="form-control">{{ item?.title || '-' }}</div>
                          </FormGroup>
                        </div>
                        <div class="box-aspek-penilaian__type">
                          <FormGroup label="Satuan Target" idinput="satuanaspek">
                            <!-- <select-form name="satuanaspek" id="satuanaspek" placeholder="Pilih Satuan" v-model="search_aspek_selected.child[index].satuan" :options="satuan_target.map((item) => { -->
                            <select-form name="satuanaspek" :id="'satuanaspek-' + index" placeholder="Pilih Satuan" v-model="search_aspek_selected.child[index].satuan" :options="list_satuan_target.map((item) => {
                              return {
                                value: item?.nama_satuan,
                                text: item?.nama_satuan,
                              };
                            })" />
                          </FormGroup>
                        </div>
                        <div class="box-aspek-penilaian__target">
                          <FormGroup label="Target" idinput="targetaspek">
                            <input-form type="number" name="target" idinput="targetaspek" placeholder="Tulis target disini..."
                              v-model=" search_aspek_selected.child[index].target" min="0" />
                          </FormGroup>
                        </div>
                        <div class="box-aspek-penilaian__action">
                          <button class="btn btn-outline-primary" @click="search_aspek_selected?.child?.length === 1 && index === 0 ? removeSearchAspek() : deleteChildAspekSelected(index)" type="button">Hapus</button>
                        </div>
                      </div>
                    </div>
                  </FieldsetComponent>
                </template>
              </div>
            </div>
            <div class="modal-footer">
              <!-- <ArgonButton type="button" color="secondary" databsdismiss="modal" ref="closeAddAspekModal">Batalkan</ArgonButton> -->
              <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" ref="closeAddAspekModal">Batalkan</button>
              <!-- <ArgonButton @click="addAspekSelected()">Simpan</ArgonButton> -->
              <button type="button" @click="addAspekSelected()" class="btn btn-primary">Simpan</button>
              <!-- <ArgonButton databsdismiss="modal" >Simpan</ArgonButton> -->
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- modal edit aspek -->
    <div class="modal fade" id="editAspekModal" tabindex="-1" aria-labelledby="editAspekModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <!-- <form @submit.prevent=" saveModal() "> -->
          <form @submit.prevent="">
            <div class="modal-header">
              <h5 class="modal-title" id="editAspekModalLabel">Ubah Target Konsolidasi</h5>
              <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
              <span class="p-1 cursor-pointer" data-bs-dismiss="modal" aria-label="Close">
                <font-awesome-icon icon="fa-solid fa-times" />
              </span>
            </div>
            <div class="modal-body">
              <div class="d-flex flex-column">
                <FieldsetComponent
                  :title="(edit_aspek_selected?.title || '')"
                  isFieldsetRow
                >
                  <!-- :title="(edit_aspek_selected?.title || '') +' - '+ (edit_aspek_selected?.jabatan || '')" -->
                  <div class="d-flex flex-column gap-2 w-100 pt-2">
                    <!-- <GridRow v-for="( item, index ) in  insertedAspek " :key=" index " :gap="-1"> -->
                    <GridRow v-for="( item, index ) in edit_aspek_selected?.child" :key=" index " :gap="-1">
                      <GridCol :md="6">
                        <FormGroup label="Aspek Penilaian" idinput="titleaspek">
                          <!-- <input type="text" class="form-control" value="Penambahan Kas Cabang" readonly> -->
                          <div class="form-control">{{ item?.title || '-' }}</div>
                        </FormGroup>
                      </GridCol>
                      <GridCol :md="2">
                        <FormGroup label="Satuan Target" idinput="satuanaspek">
                          <!-- <select-form name="satuanaspek" id="satuanaspek" placeholder="Pilih Satuan" v-model="edit_aspek_selected.child[index].satuan" :options="satuan_target.map((item) => { -->
                          <select-form name="satuanaspek" :id="'satuanaspek-edit-' + index" placeholder="Pilih Satuan" v-model="edit_aspek_selected.child[index].satuan" :options="list_satuan_target.map((item) => {
                            return {
                              value: item?.nama_satuan,
                              text: item?.nama_satuan,
                            };
                          })" />
                        </FormGroup>
                      </GridCol>
                      <GridCol :md="2">
                        <FormGroup label="Target" idinput="targetaspek">
                          <input-form type="number" name="target" idinput="targetaspek" placeholder="Tulis target disini..."
                            v-model=" edit_aspek_selected.child[index].target" min="0" />
                        </FormGroup>
                      </GridCol>
                      <!-- <GridCol :md="2">
                        <FormGroup label="Bobot" idinput="bobotaspek">
                          <input-form type="number" name="bobotaspek" idinput="bobotaspek"
                            placeholder="Tulis jumlah target" v-model=" item.bobot " />
                        </FormGroup>
                      </GridCol> -->
                      <GridCol style="text-align: right;" :md="2">
                        <br>
                        <button class="btn btn-outline-primary" @click="edit_aspek_selected?.child?.length === 1 && index === 0 ? null : deleteChildAspek(index)" type="button">Hapus</button>
                      </GridCol>
                    </GridRow>

                  </div>
                </FieldsetComponent>
              </div>
            </div>
            <div class="modal-footer">
              <!-- <ArgonButton type="button" color="secondary" databsdismiss="modal" ref="closeAddAspekModal">Batalkan</ArgonButton> -->
              <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" ref="closeEditAspekModal">Batalkan</button>
              <!-- <ArgonButton @click="addAspekSelected()">Simpan</ArgonButton> -->
              <button type="button" @click="updateAspekSelected()" class="btn btn-primary">Simpan</button>
              <!-- <ArgonButton databsdismiss="modal" >Simpan</ArgonButton> -->
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Cards from "@/components/CardComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
import FieldsetComponent from "@/views/components/FieldsetComponent.vue";
import ArgonButton from "@/components/ArgonButton.vue"
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
import MetaSection from "@/components/MetaSection.vue";
import InputForm from '@/components/InputForm.vue';
// import ListView from '@/components/ListView.vue';
import ThreeDotsMenu from "@/components/ThreeDotsMenu.vue";
import SelectForm from '@/components/SelectForm.vue';

// import AspekKinerjaApi from "@/repository/api/AspekKinerjaApi";
import KpiApi from "@/repository/api/KpiApi";
import KpiPeriodeApi from "@/repository/api/KpiPeriodeApi";
import UnitKerjaApi from '@/repository/api/UnitKerjaApi';
// import JabatanApi from "@/repository/api/JabatanApi";
import TargetKonsolidasiApi from '@/repository/api/TargetKonsolidasiApi';
import SatuanTargetApi from '@/repository/api/SatuanTargetApi';

export default {
  // name: "profile",
  components: {
    FieldsetComponent,
    Cards,
    FormGroup,
    ArgonButton,
    GridRow,
    GridCol,
    MetaSection,
    InputForm,
    // ListView,
    ThreeDotsMenu,
    SelectForm,
  },
  data() {
    return {
      // kpiCategory: [],
      // optionKpiCategory: [],
      // insertedKpiCategory: [],
      // operator: {
      //   "<": "Kurang dari",
      //   "<=": "Kurang dari samadengan",
      //   ">": "Lebih dari",
      //   ">=": "Lebih dari samadengan",
      //   "=": "samadengan",
      // },
      // showMenu: false,
      data: {
        periode_id: "",
        cabang_id: "", // unitkerja_id
        status: "",
        // aspekpenilaian: [],
        detail: [],
      },
      list_periode: [],
      unitkerja: [],
      // jabatan: [],
      // myValue: '',
      // aspekkpi: [],
      // paramsAspek: {
      //   keyword: "",
      // },
      // selectedAspek: {
      //   // id: null,
      //   aspek_id: null,
      //   // title: null,
      //   nama_aspek_kpi: null,
      //   target: null,
      //   satuan: null,
      //   bobot: null,
      // },
      // insertedAspek: [],
      // currentIndexAspek: null,
      // invalidSelectedAspekId: false,
      submitable: true,
      // ----------------------------------------------------------------------------
      // perspektif: '',
      // perspektif_list: [
      //   'finance',
      //   'customer',
      //   'internal business process',
      //   'learn & growth',
      // ],

      timer: null,
      list_search_aspek: [],
      keyword_search_aspek: [],
      search_aspek_selected: null,

      list_aspek_selected: [],
      index_aspek_selected: null,

      edit_aspek_selected: null,
      list_satuan_target: [],
      // satuan_target: [
      //   {
      //     value: 'rupiah',
      //     label: 'Rupiah'        
      //   },
      //   {
      //     value: 'persen',
      //     label: 'Persen/Hari/Skala Nilai'        
      //   },
      //   {
      //     value: 'pcs',
      //     label: 'Pcs'        
      //   }
      // ],
    };
  },
  watch: {
    // // 'selectedAspek.id': {
    // 'selectedAspek.aspek_id': {
    //   handler: async function (newVal) {
    //     if (this.insertedAspek.map((item) => { return item.aspek_id }).includes(newVal)) {
    //       this.invalidSelectedAspekId = true;
    //     }
    //     else {
    //       this.invalidSelectedAspekId = false;
    //     }
    //     // this.selectedAspek['title'] = null;
    //     this.selectedAspek['nama_aspek_kpi'] = null;
    //     this.selectedAspek['target'] = null;
    //     this.selectedAspek['satuan'] = null;
    //     this.selectedAspek['bobot'] = null;
    //   },
    //   deep: true,
    // },
    // 'data.unit_kerja_id': {
    //   handler: async function () {
    //     // this.data.jabatan_id = null;
    //     await this.getJabatan()
    //   },
    //   deep: true,
    // },
  },
  methods: {
    validateInput(field, data) {
      let test = Boolean
      switch (field) {
        case "name":
          test = /^([\w!@#$%^&*(),.?":{}|<>-](\s?))+$/.test(data)
          break;
        case "prespektif":
          test = /^.+$/.test(data)
          break;
        default:
          break;
      }
      this.submitable = test
      return test;
    },
    // showKategori() {
    //   return this.insertedKpiCategory.length > 0 || this.data.aspekpenilaian.length > 0;
    // },
    // saveModal() {
    //   // // this.insertedKpiCategory[this.currentIndexAspek]['sub'] = JSON.parse(JSON.stringify(this.insertedAspek));

    //   // // this.insertedAspek.nama_aspek_kpi = this.aspekkpi.find((itm) => { return itm.id == this.insertedAspek.id })?.name || '';
    //   // // console.log(this.aspekkpi.find((itm) => { return itm.id == this.insertedAspek.id })?.name)

    //   // if (!this.insertedAspek) {
    //   //   this.$swal({
    //   //     icon: "error",
    //   //     title: "ERROR",
    //   //     text: "Sub aspek penilaian belum ditambahkan",
    //   //   });

    //   //   return;
    //   // }

    //   // this.insertedAspek.forEach((item, index) => {
    //   //   this.insertedAspek[index].nama_aspek_kpi = this.aspekkpi.find((itm) => { return itm.id == item.aspek_id })?.name || '';
    //   // });
    //   // if (this.$route.params?.id) {
    //   //   this.insertedAspek.sub_kpi_id = '';
    //   // }

    //   // this.insertedKpiCategory[this.currentIndexAspek]['sub'] = this.insertedAspek;
    // },
    // addAspek() {
    //   // if (this.selectedAspek.id != null && this.selectedAspek.target != null && this.selectedAspek.satuan != null && this.selectedAspek.bobot != null) {
    //   if (this.selectedAspek.aspek_id != null && this.selectedAspek.target != null && this.selectedAspek.satuan != null && this.selectedAspek.bobot != null) {
    //     this.insertedAspek.push(JSON.parse(JSON.stringify(this.selectedAspek)));
    //     this.selectedAspek = {
    //       // id: null,
    //       aspek_id: null,
    //       // title: null,
    //       nama_aspek_kpi: null,
    //       target: null,
    //       satuan: null,
    //       bobot: null,
    //     };
    //   }
    //   else {
    //     this.$swal({
    //       icon: "error",
    //       title: "ERROR",
    //       text: "Pencarian aspek belum di isi dengan benar"
    //     });
    //   }
    // },
    // deleteInsertedAspek(index_aspek) {
    //   this.insertedAspek.splice(index_aspek, 1);
    // },
    // async getAspekKpi() {
    //   this.$store.state.loading = true;
    //   // await AspekKinerjaApi.get(
    //   await AspekKinerjaApi.getbyparam({
    //     master: 1,
    //     page: 'all',
    //   })
    //     .then((response) => {
    //       this.aspekkpi = response.data;
    //     }).catch(() => {
    //       this.aspekkpi = [];
    //     });
    //   this.$store.state.loading = false;
    // },

    async getSatuanTarget() {
      await SatuanTargetApi.get()
        .then((response) => {
          // console.log(response?.data);
          this.list_satuan_target = response?.data || [];
        })
        .catch((err) => {
          console.log(err)
        });
    },
    async getKpiPeriode() {
      await KpiPeriodeApi.getbyparam({
        status: 'active',
        limit: 100,
      })
        .then((response) => {
          this.list_periode = response?.data || [];
        })
        .catch((err) => {
          console.log(err)
        });
    },
    async getUnitKerja() {
      await UnitKerjaApi.getbyparam({
        page: 'all',
        status: 'active',
        level: 1,
      })
        .then((response) => {
          this.unitkerja = response.data;
        }).catch(() => {
          this.params.jabatan_id = null;
          this.unitkerja = [];
        });
    },

    async getAspeKategori() {
      this.$store.state.loading = true;
      await KpiApi.getByParamsNew({
        page: 'all',
        is_group: false,
        keyword: this.keyword_search_aspek,
        unitkerja_id: this.data.cabang_id,
      })
        .then((response) => {
          this.list_search_aspek = response?.data || [];
        })
        .catch((err) => {
          console.log(err)
        });
      this.$store.state.loading = false;
    },

    async searchKeywordAspek() {
      clearTimeout(this.timer);
      this.timer = setTimeout(async () => {

        if (this.keyword_search_aspek.length > 0) {

          this.list_search_aspek = [];
            
          await this.getAspeKategori();
        } else {

          this.list_search_aspek = [];
        }
      }, 1000)
    },

    chooseSearchAspek(item) {
      this.search_aspek_selected = item;
    },

    removeSearchAspek() {
      this.search_aspek_selected = null;
      this.keyword_search_aspek = '';
      this.list_search_aspek = [];
    },

    deleteChildAspekSelected(index) {
      if (this.search_aspek_selected?.child?.[index]) {
        this.search_aspek_selected.child.splice(index, 1)
      }
    },

    addAspekSelected() {
      if (this.search_aspek_selected === null) {
        this.$swal({
          icon: "error",
          title: "Aspek target konsolidasi perlu diisi!",
        });
        return;
      }

      this.list_aspek_selected.push(JSON.parse(JSON.stringify(this.search_aspek_selected)))

      this.removeSearchAspek()
      this.$refs.closeAddAspekModal.click();
    },

    deleteAspekSelected(index) {
      if (this.list_aspek_selected?.[index]) {
        this.list_aspek_selected.splice(index, 1)
      }
    },

    editAspek(index, item) {
      this.index_aspek_selected = index;
      this.edit_aspek_selected = JSON.parse(JSON.stringify(item));
    },

    deleteChildAspek(index) {
      if (this.edit_aspek_selected?.child?.[index]) {
        this.edit_aspek_selected.child.splice(index, 1)
      }
    },

    updateAspekSelected() {
      // if (this.edit_aspek_selected?.child?.[index]) {
      //   this.edit_aspek_selected.child.splice(index, 1)
      // }

      this.list_aspek_selected[this.index_aspek_selected] = JSON.parse(JSON.stringify(this.edit_aspek_selected));
      this.edit_aspek_selected = null;
      this.$refs.closeEditAspekModal.click();
    },

    resetModalAddAspek() {
      this.list_search_aspek = [];
      this.keyword_search_aspek = [];
      this.search_aspek_selected = null;
    },

    // -----------------------------------------------------------------------------------------------------------------------------

    // async addCategoryKpi() {
    //   if (this.data.categorykpi != "" && this.data.categorykpi != null && this.data.categorykpi != undefined) {
    //     if (this.insertedKpiCategory.map((item) => { return item?.title }).includes(this.data.categorykpi)) {
    //       this.$swal({
    //         icon: "error",
    //         title: "Kategori sudah ada"
    //       })
    //     }
    //     else {
    //       this.insertedKpiCategory.push({
    //         // title: this.data.categorykpi,
    //         // nama_penilaian_kinerja: this.data.categorykpi,
    //         title: this.data.categorykpi,
    //         perspektif: "",
    //         sub: [],
    //       })
    //     }
    //     this.data.categorykpi = null;
    //   }
    // },
    // async getKpiCategory() {
    //   this.$store.state.loading = true;
    //   await KpiApi.getByParamsNew({view_option: 1}).then((response) => {
    //     this.kpiCategory = response.data;
    //   }).catch(() => {
    //     this.kpiCategory = [];
    //   });
    //   // await this.getOptionKpiCategory();
    //   this.$store.state.loading = false;
    // },
    // async getOptionKpiCategory() {
    //   this.optionKpiCategory = this.kpiCategory.map((item) => {
    //     return {
    //       id: item.id,
    //       text: item.title,
    //     };
    //   })
    //   // console.log(this.optionKpiCategory)
    // },
    async submit() {

      // if (this.insertedKpiCategory?.length === 0 || this.insertedKpiCategory?.[0]?.sub?.length === 0) {
      if (this.list_aspek_selected?.length === 0) {
        this.$swal({
          icon: "error",
          title: "Aspek target konsolidasi perlu diisi!",
        });
        return;
      }

      console.log('lolos validasi')
      
      this.$store.state.loading = true;
      let data = JSON.parse(JSON.stringify(this.data));

      console.log('form submit')
      console.log(data)
      console.log(this.list_aspek_selected)

      let data_aspek = [];

      this.list_aspek_selected.forEach(item => {
        item.child.forEach(item_child => {
          data_aspek.push({
            aspekpenilaian_id: item_child.aspekpenilaian_id,
            satuan: item_child.satuan,
            target: item_child.target,
          })
        });
      });

      data.detail = JSON.stringify(data_aspek);

      // edit
      if (this.$route.params.id) {
        // data.append('is_kpibaru', "1")
        // await KpiApi.updateNew(this.$route.params.id, data).then(() => {
        // data.id = this.$route.params.id;
        await TargetKonsolidasiApi.update(this.$route.params.id, data)
          .then(() => {
            this.$swal({
              icon: "success",
              title: "Berhasil",
            }).then(() => {
              this.$router.push({ name: "Target Konsolidasi" });
            });
          }).catch((error) => {
            this.$swal({
              icon: "error",
              title: error?.response?.data?.message || 'Something wrong, please try again.',
            });
          });

      // create
      } else {
        await TargetKonsolidasiApi.create(data)
          .then(() => {
            this.$swal({
              icon: "success",
              title: "Berhasil",
            }).then(() => {
              this.$router.push({ name: "Target Konsolidasi" });
            });
          }).catch((error) => {
            this.$swal({
              icon: "error",
              title: error?.response?.data?.message || 'Something wrong, please try again.',
            });
          });
      }
      this.$store.state.loading = false;
    },
    async getData() {
      this.$store.state.loading = true;
      await TargetKonsolidasiApi.getDetail(this.$route.params.id)
        .then((response) => {
          // console.log(response?.data)
          const data = response?.data;

          if (data) {
            // this.data.title = data?.title || '';
            this.data.periode_id = data?.periode_id || '';
            this.data.cabang_id = data?.unitkerja_id || '';
            this.data.status = data?.status || '';
  
            this.list_aspek_selected = data?.list_kpi?.map((item) => {
              item.title = item?.kpi;

              item.child = item?.sub_kpi?.map(item_child => {
                item_child.satuan = item_child.satuan_konsolidasi;
                item_child.target = item_child.target_konsolidasi;

                return item_child;
              });

              delete item.list_kpi;

              return item;
            })
          }
        })
        .catch((error) => {
          console.log(error)
          this.$swal({
            icon: "error",
            title: error?.response?.data?.message || 'Something wrong, please try again.',
          });
        })
      this.$store.state.loading = false;
    },
    // getSatuan(satuan) {
    //   let result = null
    //   try {
    //     result = this.satuan_target.find(({ value }) => value === satuan);
    //     result = result.label
    //   } catch (error) {
    //     result = satuan
    //   }
    //   return result
    // }
  },
  async mounted() {
    this.$store.state.loading = true;
    // await this.getKpiCategory();
    await this.getKpiPeriode();
    await this.getUnitKerja();
    // await this.getAspekKpi();
    await this.getSatuanTarget();
    
    if (this.$route.params.id) {
      await this.getData();
    }
    // await this.getEmployee();
    this.$store.state.loading = false;
  },
};
</script>

<style scoped>
.box-aspek-main {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.box-aspek-penilaian {
  display: flex;
  gap: 24px;
  justify-content: space-between;
  align-items: flex-end;
}
.box-aspek-penilaian > div {
  flex-grow: 1;
}

.box-aspek-penilaian .form-group {
  margin-bottom: 0;
}

.box-aspek-penilaian__value {
  min-width: 45%
}
.box-aspek-penilaian__action {
  flex-grow: 0 !important;
}

.box-aspek-penilaian__type {
  max-width: 144px;
}

.box-aspek-penilaian__action button {
  margin-bottom: 0;
  height: 40px;
  line-height: 40px;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}



</style>